document.addEventListener('DOMContentLoaded', function() {
  const banner = document.querySelector('.banner'); // Replace with your banner's class
  console.log(banner);
  const videoUrl = 'https://cdn.shopify.com/videos/c/o/v/62244e7f260145c689982cb6bcea1cc2.mp4'; // Replace with your video URL
  
  if (banner) {
    console.log('this fires');
    const video = document.createElement('video');
    video.src = videoUrl;
    video.muted = true; // Must be muted for autoplay to work on most browsers
    video.autoplay = true;
    video.loop = true; // Makes the video loop continuously
    video.playsInline = true; // Required for autoplay on iOS
    video.style.width = '100%';
    video.style.height = 'auto';
    
    // Replace the banner itself with the video
    banner.replaceWith(video);
  }
});
